export default __webpack_public_path__ + "static/media/Growth Copilot-coming.22a96cbd.png";